import { iAeonDoCodeRead } from '../library/iaeon_sdk.js';

export const zxingScan = () => {

//5.バーコード・QRコード読み取りAPI
console.log("【iAeonDoCodeRead】call");

return new Promise((resolve, reject) => {
	let successCall_5 = function(success){
		console.log('【iAeonDoCodeRead】success: ', success);
		console.log('【iAeonDoCodeRead】data: ' + success.data);
		resolve(success.data); // 成功した場合、data を resolve します
	};
	let errorCall_5 = function(error){
		console.log('【iAeonDoCodeRead】error: ' + error.error_code + " : " + error.message);
		reject(error); // エラーが発生した場合、reject します
	};
	iAeonDoCodeRead({"type":"bar"}).then(successCall_5).catch(errorCall_5);
	// window.iAeonMiniApp.iAeonDoCodeRead({"type":"bar"}).then(successCall_5).catch(errorCall_5);
});

};
